import { render, staticRenderFns } from "./process-alarm-modal.vue?vue&type=template&id=4b1830e6"
import script from "./process-alarm-modal.vue?vue&type=script&lang=js"
export * from "./process-alarm-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports